// extracted by mini-css-extract-plugin
export default {"PostListGrid":"PostListGrid-module-PostListGrid-2kc","postListGrid":"PostListGrid-module-PostListGrid-2kc"};